"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var jsonrpc_1 = require("./jsonrpc");

var LegacyProviderAdapter = /*#__PURE__*/function () {
  function LegacyProviderAdapter(provider) {
    _classCallCheck(this, LegacyProviderAdapter);

    this.provider = provider;
    this.eventEmitter = new events_1.EventEmitter();
  }

  _createClass(LegacyProviderAdapter, [{
    key: "subscribeToLegacyProvider",
    value: function subscribeToLegacyProvider() {
      var _this = this;

      if (!this.provider.on) {
        throw new Error('Legacy provider does not support subscriptions.');
      }

      this.provider.on('data', function (result, deprecatedResult) {
        result = result || deprecatedResult;

        if (!result.method) {
          return;
        }

        _this.eventEmitter.emit('notification', result.params);
      });
    }
  }, {
    key: "send",
    value: function send(method, params) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var payload = jsonrpc_1.createJsonRpcPayload(method, params);

        _this2.provider.send(payload, function (err, message) {
          if (err) {
            return reject(err);
          }

          if (!message) {
            return reject(new Error('No response.'));
          }

          if (!jsonrpc_1.isValidJsonRpcResponse(message)) {
            var msg = message.error && message.error.message ? message.error.message : 'Invalid JSON RPC response: ' + JSON.stringify(message);
            return reject(new Error(msg));
          }

          var response = message;

          if (response.error) {
            var _message = response.error.message ? response.error.message : JSON.stringify(response);

            return reject(new Error('Returned error: ' + _message));
          }

          if (response.id && payload.id !== response.id) {
            return reject(new Error("Wrong response id ".concat(payload.id, " != ").concat(response.id, " in ").concat(JSON.stringify(payload))));
          }

          resolve(response.result);
        });
      });
    }
  }, {
    key: "on",
    value: function on(notification, listener) {
      if (notification !== 'notification') {
        throw new Error('Legacy providers only support notification event.');
      }

      if (this.eventEmitter.listenerCount('notification') === 0) {
        this.subscribeToLegacyProvider();
      }

      this.eventEmitter.on('notification', listener);
      return this;
    }
  }, {
    key: "removeListener",
    value: function removeListener(notification, listener) {
      if (!this.provider.removeListener) {
        throw new Error('Legacy provider does not support subscriptions.');
      }

      if (notification !== 'notification') {
        throw new Error('Legacy providers only support notification event.');
      }

      this.eventEmitter.removeListener('notification', listener);

      if (this.eventEmitter.listenerCount('notification') === 0) {
        this.provider.removeAllListeners('data');
      }

      return this;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(notification) {
      this.eventEmitter.removeAllListeners('notification');

      if (this.provider.removeAllListeners) {
        this.provider.removeAllListeners('data');
      }
    }
  }]);

  return LegacyProviderAdapter;
}();

exports.LegacyProviderAdapter = LegacyProviderAdapter;